import FreeBusyType from '../schema/FreeBusyType';

/**
 * Converts a FreeBusyType value to a boolean whether it's tentative block.
 * @param freeBusy FreeBusyType value
 */
export default function isTentativeFromFreeBusy(
    freeBusy: FreeBusyType,
    isResource?: boolean
): boolean {
    // Right now we are not distinguishing tentative from free/busy for resources
    return !isResource && freeBusy == FreeBusyType.Tentative;
}
